<template>
    <div class="policy-consent-checkbox">
        <ui-checkbox-with-text v-model="localAccepted">
            <span class="policy-consent-checkbox__text" :class="{'_small': small}">
                Я <a :href="consentUrl" target="_blank">согласен</a>
                на обработку персональных данных и ознакомлен с условиями
                <a :href="urls.policies.privacyPolicy" target="_blank">Политики конфиденциальности</a>
            </span>
        </ui-checkbox-with-text>
        <div
            class="policy-consent-checkbox__error"
            v-if="showError"
            v-text="errorMessage"
        />
    </div>
</template>

<script>
import config from '~/config';

export default {
    name: 'policy-consent-checkbox',
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        showError: {
            type: Boolean,
        },
        errorMessage: {
            type: String,
            default: 'Необходимо ваше согласие',
        },
        small: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        urls: config.urls,
    }),
    model: {
        prop: 'checked',
        event: 'change',
    },
    methods: {

    },
    computed: {
        localAccepted: {
            get() {
                return this.checked;
            },
            set(newValue) {
                this.$emit('change', newValue);
            },
        },
        consentUrl() {
            return this.urls.policies.consent[this.variant];
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.policy-consent-checkbox {
    &__text {
        .typography-body();

        &._small {
            .typography-caption();
        }
    }

    &__error {
        .typography-body();

        margin-top: 16px;

        color: @color-accent-negative;
        text-align: center;
    }

}
</style>
